module.exports = __webpack_public_path__ + "static/img/channelD.0c05d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/channelD.png
// module id = TeaF
// module chunks = 83